import Store from 'lib/Store';

import { ActionTypes } from '../constants/MessageComposerConstants';
import { Backbone$Id } from 'types/typescript/Backbone';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class MessageComposerStore extends Store {
  getInitialState() {
    return {
      composerStates: {},
    };
  }

  getComposerStates(chatId: Backbone$Id) {
    return this.state.composerStates[chatId];
  }

  setComposerStates(chatId: Backbone$Id, state: Object) {
    this.state.composerStates[chatId] = state;
  }

  handleDispatch(action: any): void {
    switch (action.type) {
      case ActionTypes.SAVE_STATE:
        this.setComposerStates(action.chatId, action.state);
        this.emitChange();
        break;
      default:
        break;
    }
  }
}

export default new MessageComposerStore();
